/*
Available extended methods (super may be required!)
- refresh                       - runs when drupal is refreshed or can be run internally when required

Available methods
- onReady                       - runs when (min-width: 0rem) is hit
- onMobileNavInit               - runs when (max-width: 46.875rem) is hit
- onMobileNavDestroy            - runs when (max-width: 46.875rem) is hit

Available methods when Config.pluginswindowListenerPlugin.scroll == true
- scroll                        - runs every time scroll events are fired
- debouncedScroll               - runs every configured Xms to delay scroll events and improve performance
- delayedDebouncedScroll        - runs every time scroll events end firing after configured Xms

Available methods when Config.pluginswindowListenerPlugin.resize == true
- resize                        - runs every time resize events are fired
- debouncedResize               - runs every configured Xms to delay resize events and improve performance
- delayedDebouncedResize        - runs every time resize events end firing after configured Xms
*/

// imports
import MainApp from 'minsky-kit/js/managers/MainApp';
import InstanceManager from 'minsky-kit/js/managers/InstanceManager';

import EmbedVideo from 'minsky-kit/js/components/EmbedVideo';
import { prepSvgMask } from 'minsky-kit/js/utils/svg';
import Config from './Config'; // keep even though we don't use it
import HeroCarousel from './minsky/components/HeroCarousel';
import NewsCarousel from './minsky/components/NewsCarousel';
import MediaCarousel from './minsky/components/MediaCarousel';
import Header from './minsky/components/Header';
import ReservationView from './minsky/components/ReservationView';
import MenuAccordion from './minsky/components/MenuAccordion';
import { refreshBlips } from './minsky/utils/blips';
import BookerOverlay from './minsky/components/BookerOverlay';
import FAQAccordion from './minsky/components/FAQAccordion';

// import gsap
// get plugins:
// register plugins

// class
export default class ProjectApp extends MainApp {
    // export default class ProjectApp extends MinskyApp {
    // constructor
    constructor (args = {}) {
        // set app instance debug state
        args.debug = false;

        // call super constructor
        super(args, 'Project App');

        // properties
        this._im = new InstanceManager(); // https://bitbucket.org/Minsky_WebAgency/minsky-kit/src/master/documentation/InstanceManager.md

        // prep some svg masks

        // render masks from certain svgs
        this.once('spritesheetsLoaded', () => {
            // prep some masks using svg's in the spritesheet
            prepSvgMask(
                'location-blob',
                'btn-shape',
                'btn-shape-v-flip',
            );
        });

        refreshBlips();
    }

    // methods
    onReady () {
        this.log('App ready');

        const $hero = document.querySelector('.header-slider-p .view-rows');
        if ($hero) {
            new HeroCarousel({
                $el:      $hero,
                settings: {
                    fadeEffect: { crossFade: true },
                    effect:     'fade',
                },
            });
        }

        // video embeds
        this._im.initAddComponent('reservation-views', ReservationView, '.view--store-reservation');

        // video embeds
        this._im.initAddComponent('embed-video', EmbedVideo, '.embed-video');

        // video embeds
        this._im.initAddComponent('embed-video', EmbedVideo, '.embed-video');

        // simple accordions
        this._im.initAddComponent('menu-accordions', MenuAccordion, '.menu-item .accordion');

        this._im.initAddComponent('faq-accordion', FAQAccordion, '.faq-p__item');

        // News carousel
        this._im.initAddComponent('.news-carousels', NewsCarousel, '.news-slider .view-rows');

        // Media carousel
        this._im.initAddComponent('.media-carousels', MediaCarousel, '.media-p--as-carousel .media-p__content');

        // init header
        this._im.initAddComponent('header', Header, '.header');

        // init booker overlay on store teasers
        this._im.initAddComponent('booker-overlays', BookerOverlay, '.store-t__button--reservation', ($el) => {
            const $parentWithId = $el.closest('[data-table-booker-id]');
            const params = {
                $trigger: $el,
            };
            if ($parentWithId) {
                params.id = $parentWithId.dataset.tableBookerId;
            }
            return params;
        });
    }

    refresh () {
        this.log('App refresh');

        refreshBlips();

        super.refresh();
    }

    resize () {
        this.log('App resize');

        if (this.scrollHeader) {
            this.scrollHeader.refresh();
        }
    }

    delayedDebouncedResize () {
        this.log('App debounced resize');

        this._im.run([
            'header',
            'menu-accordions',
        ], 'refresh');
    }

    scroll () {
        this.log('App scroll');
    }

    debouncedScroll () {
        this.log('App debounced scroll');

        this._im.run([
            'header',
        ], 'scrollRefresh');
    }

    onMobileNavInit () {
        this.log('Mobile');

        this._im.run([
            'header',
            'menu-accordions',
        ], 'mobile', true);
    }

    onMobileNavDestroy () {
        this.log('Desktop');

        this._im.run([
            'header',
            'menu-accordions',
        ], 'mobile', false);
    }
}

// utilities

// event handlers
